import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as pdfjsLib from "pdfjs-dist";

// Configure PDF.js worker globally - do this ONCE before any PDF components load
pdfjsLib.GlobalWorkerOptions.workerSrc = `${window.location.origin}${process.env.PUBLIC_URL || ""}/pdf.worker.min.mjs`;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
